/* RESPONSIBLE TEAM: team-data-foundations */
import IntercomRoute from 'embercom/routes/base/intercom-route';

export default IntercomRoute.extend({
  beforeModel() {
    this.transitionTo('apps.app.developer-hub');
  },
});
